import React, { lazy } from 'react'
import {
  ViewType,
  HideRetailerAgnosticStoreConfigs,
  OnlyStorefrontOrStorefrontPro,
  type RetailerScopeWrapperProps,
} from '@retailer-platform/dashboard/gin-and-tonic'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { siteManagementNavigationAccessControl } from '../access-control/siteManagementNavigationAccess.configuration.ts'

const NavigationDesktopPage = lazy(() => import('../pages/navigation/NavigationDesktopPage'))
const NavigationMobileWebPage = lazy(() => import('../pages/navigation/NavigationMobileWebPage'))
const NavigationNativePage = lazy(() => import('../pages/navigation/NavigationNativePage'))
const NavigationGlobalMenusPage = lazy(
  () => import('../pages/navigation/NavigationGlobalMenusPage')
)
const NavigationDesktopStylesPage = lazy(
  () => import('../pages/navigation/NavigationDesktopStylesPage')
)
const NavigationMwebStylesPage = lazy(
  () => import('../pages/navigation/NavigationMobileWebStylesPage')
)
const NavigationNativeStylesPage = lazy(
  () => import('../pages/navigation/NavigationNativeStylesPage')
)
// @hygen:inject page-import

const commonNavigationScopePicker = {
  titles: ['siteManagementDomain.title'],
  selectionType: ViewType.RETAILER_AND_STORE_CONFIG,
  storeConfigOperationIntent: 'modify',
  storeConfigFilter: HideRetailerAgnosticStoreConfigs,
} as RetailerScopeWrapperProps

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const siteManagementRouter = (
  <DomainRoute route="site-management">
    <DashSwitch>
      <DomainRoute
        exact
        route="site-management-navigation-desktop"
        component={NavigationDesktopPage}
        accessControl={siteManagementNavigationAccessControl}
        scopePicker={commonNavigationScopePicker}
      />
      <DomainRoute
        exact
        route="site-management-navigation-desktop-storefront-pro"
        component={NavigationDesktopPage}
        accessControl={siteManagementNavigationAccessControl}
        scopePicker={{
          ...commonNavigationScopePicker,
          storeConfigFilter: sites =>
            OnlyStorefrontOrStorefrontPro(HideRetailerAgnosticStoreConfigs(sites)),
        }}
      />
      <DomainRoute
        exact
        route="site-management-navigation-mweb"
        component={NavigationMobileWebPage}
        accessControl={siteManagementNavigationAccessControl}
        scopePicker={commonNavigationScopePicker}
      />
      <DomainRoute
        exact
        route="site-management-navigation-native"
        component={NavigationNativePage}
        accessControl={siteManagementNavigationAccessControl}
        scopePicker={commonNavigationScopePicker}
      />
      <DomainRoute
        exact
        route="site-management-navigation-global-menus"
        component={NavigationGlobalMenusPage}
        accessControl={siteManagementNavigationAccessControl}
        scopePicker={commonNavigationScopePicker}
      />
      <DomainRoute
        exact
        route="site-management-navigation-desktop-styles"
        component={NavigationDesktopStylesPage}
        accessControl={siteManagementNavigationAccessControl}
        scopePicker={commonNavigationScopePicker}
      />
      <DomainRoute
        exact
        route="site-management-navigation-mweb-styles"
        component={NavigationMwebStylesPage}
        accessControl={siteManagementNavigationAccessControl}
      />
      <DomainRoute
        exact
        route="site-management-navigation-native-styles"
        component={NavigationNativeStylesPage}
        accessControl={siteManagementNavigationAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
